import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreServiceService } from '../core/core-service.service';
import { SelectLiveBooking } from '../Models/SelectLiveBooking';

@Injectable({
  providedIn: 'root'
})
export class LiveParkflyService {
  private BaseApiPath: string;
  constructor(private http: HttpClient, private coreService: CoreServiceService) {

    this.BaseApiPath = this.coreService.appSettings && this.coreService.appSettings.ParkBaseApiPath;

  }

  public SelectLiveBooking(): Observable<SelectLiveBooking[]> {
    const ApiUrl = this.BaseApiPath + 'PreBooking/SelectLiveBooking';
    return this.http.get<SelectLiveBooking[]>(ApiUrl);
  }

}
